import Utils from '@/plugins/sheep/utils'
import Actions from '@/plugins/sheep/actions'
import Configs from '@/plugins/sheep/configs'

/**
 * Sheep Factory
 */
export default class Sheep {
  constructor () {
    this.utils = Utils
    this.actions = Actions
    this.configs = Configs
  }

  /**
     * Accepts a file and will parse it into a 2D array
     *
     * @param  {[type]}
     * @return {[type]}
     */
  parseFileToArray (file, callback) {
    this.utils.loadFile(file, (sheet) => {
      callback(this.utils.sheetToArray(sheet.Sheets[sheet.SheetNames[0]]))
    })
  }

  applyActions (input, actions) {
    // Setup output an array of empty objects
    // https://stackoverflow.com/questions/35578478/array-prototype-fill-with-object-passes-reference-and-not-new-instance
    var output = Array(input.length).fill().map(u => ({}))

    // Apply the actions
    for (var key in actions) {
      this.actions[actions[key].action](input, output, actions[key].params)
    }

    // Return the result
    return output
  }

  getConfig (name) {
    return this.configs[name]()
  }
}
